<template>
  <div class="layout-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
}
</script>

<style lang="scss">
</style>
